import { ref } from 'vue';
import { defineStore } from 'pinia';

import ApiEvents from '@/api/ApiEvents';
import { useUserStore } from '@/stores/user';

import type {
	EventGroupListResponse,
	EventGroupRaw,
	EventUnreadCountResponse,
} from '@/api/ApiTypes';


export const useEventsStore = defineStore('events', () => {
	const unreadCount = ref(0);
	const isLoading = ref(false);
	const events = ref<EventGroupRaw[]>([]);
	const showArchived = ref(false);

	const userStore = useUserStore();

	const update = (newUnreadCount: number, newEvents: EventGroupRaw[]): void => {
		unreadCount.value = newUnreadCount;
		events.value = newEvents;
	};

	const handleUnreadCount = (response: EventUnreadCountResponse): void => {
		update(response.unread_count, events.value);
	};

	const handleUnreadCountError = (): void => {
		update(0, events.value);
	};

	const refreshUnreadCount = (): void => {
		if (userStore.allowToSeeModuleStatuses) {
			ApiEvents.eventGroupGetUnreadCount(handleUnreadCount, handleUnreadCountError);
		}
	};

	const handleAll = (response: EventGroupListResponse): void => {
		update(response.unread_count, response.events);
		isLoading.value = false;
	};

	const handleAllError = (): void => {
		update(0, []);
		isLoading.value = false;
	};

	const refreshAll = (): void => {
		if (userStore.allowToSeeModuleStatuses) {
			isLoading.value = true;
			ApiEvents.eventGroupGetList(showArchived.value, handleAll, handleAllError);
		}
	};

	const setShowArchived = (newShowArchived: boolean): void => {
		showArchived.value = newShowArchived;
	};

	return {
		unreadCount,
		isLoading,
		events,
		showArchived,
		update,
		refreshUnreadCount,
		refreshAll,
		setShowArchived,
	};
});
